import type { DomainManifest } from 'modules/core/lib/manifests/types'
import type { Navigation, NavigationPaths } from 'modules/core/lib/navigation/context'

import { AddCommentAction } from 'modules/posts/lib/oneHandlers/add-comment'
import { AddMembersAction } from 'modules/posts/lib/oneHandlers/add-members'
import { ArchiveGroupAction } from 'modules/posts/lib/oneHandlers/archive-group'
import { CreateGroupAction } from 'modules/posts/lib/oneHandlers/create-group'
import { CreatePostAction } from 'modules/posts/lib/oneHandlers/create-post'
import { DeleteCommentAction } from 'modules/posts/lib/oneHandlers/delete-comment'
import { DeleteGroupAction } from 'modules/posts/lib/oneHandlers/delete-group'
import { DeletePostAction } from 'modules/posts/lib/oneHandlers/delete-post'
import { RemoveMembersAction } from 'modules/posts/lib/oneHandlers/remove-members'
import { SchedulePostAction } from 'modules/posts/lib/oneHandlers/schedule-post'
import { UpdateCommentAction } from 'modules/posts/lib/oneHandlers/update-comment'
import { UpdateGroupAction } from 'modules/posts/lib/oneHandlers/update-group'
import { UpdatePostAction } from 'modules/posts/lib/oneHandlers/update-post'

export const manifest = {
  sidebar: (_navigation: Navigation<NavigationPaths>) => ({
    items: [],
  }),
  one: {
    createActions: {
      post: CreatePostAction,
      updatePost: UpdatePostAction,
      deletePost: DeletePostAction,
      schedulePost: SchedulePostAction,
      addComment: AddCommentAction,
      updateComment: UpdateCommentAction,
      deleteComment: DeleteCommentAction,
      createGroup: CreateGroupAction,
      updateGroup: UpdateGroupAction,
      archiveGroup: ArchiveGroupAction,
      addMembers: AddMembersAction,
      removeMembers: RemoveMembersAction,
      deleteGroup: DeleteGroupAction,
    },
  },
} as const satisfies DomainManifest
